<template>
  <Grid />
</template>
<script>
import Grid from './components/grid'

export default {
  name: 'ecom-shipment-management-shipment-orders',
  components: { Grid },
}
</script>
